/**
 * INTESTINAL RESOLVER (MEV5)
 * Mechanism: Nutrient Absorption (Gut -> Blood)
 * Standard: Mari-Groop Flux (2002)
 */

import { V5PhysiologicalState as PhysiologicalState, ClinicalFraction } from '../types';

export const IntestinalResolver = {
    
    /**
     * Calculates the grams of a specific fraction entering the blood plasma per minute.
     * @param state Current physiological state
     * @param fraction The specific nutrient (e.g., glucose, lipids)
     * @param absorptionRate The specific K_abs for this fraction
     */
    compute(state: PhysiologicalState, fraction: ClinicalFraction, absorptionRate: number): number {
        const comp = state.fractions[fraction];
        if (comp.gut <= 0) return 0;

        // ABSORPTION FLUX
        // Simple linear flux based on the available pool in the small intestine.
        const flow = comp.gut * absorptionRate;
        
        return Math.min(comp.gut, flow);
    }
};
